import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';


import { Notification } from './notifications.model';

@Injectable()
export class NotificationsService {
    private _notifications = new Subject<Notification>();
    public noteAdded = this._notifications.asObservable();


    public add(notification: Notification) {
        this._notifications.next(notification);
    }
    
}